export default __webpack_public_path__ + "static/media/ts-2-2.5669004d.svg";